export const siteSettings = {
  name: "Avax Trade",
  link: "https://avaxtrade.io",
  email: "support@avaxtrade.io",
  appLink: "https://app.avaxtrade.io",
};
